import type { UsbDevice } from "@/lib/api";

const ID_KEY_PREFIX = "id:";
const PORT_KEY_PREFIX = "port:";

/** 一覧に出す機器の名前。USB の文字列が無ければ vendor:product、それも無ければ「USB 機器」 (backend の RunnerUsbDevices.Describe と同じ)。 */
export function usbDeviceName(device: UsbDevice): string {
	const name = [device.manufacturer, device.product].filter(Boolean).join(" ");
	if (name) return name;
	if (device.vendorId && device.productId) return `${device.vendorId}:${device.productId}`;
	return "USB 機器";
}

/** 機器の見分け方。キーがシリアル番号ならシリアル番号、差した口なら差した口。 */
export function usbDeviceIdentity(device: UsbDevice): string {
	if (device.key.startsWith(PORT_KEY_PREFIX)) {
		return `差した口 ${device.port ?? device.key.slice(PORT_KEY_PREFIX.length)}`;
	}
	if (device.key.startsWith(ID_KEY_PREFIX)) {
		// id:<vid>:<pid>:<serial>
		const serial = device.serial ?? device.key.split(":")[3];
		return `シリアル番号 ${serial}`;
	}
	return device.key;
}
